<script setup>
defineOptions({
  inheritAttrs: false,
})

defineProps({
  fluid: {
    type: Boolean,
    default: false,
  },
  fluidWithContainedContent: {
    type: Boolean,
    default: false,
  },
  addVerticalSpace: {
    type: Boolean,
    default: false,
  },
  addVerticalSpace: {
    type: Boolean,
    default: false,
  },
  reducedPadding: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'transparent',
  },
  text: {
    type: String,
    default: '',
  },
  imageGrid: {
    type: Object,
    default: null,
  },
  headline: {
    type: Object,
    default: null,
  },
})
</script>

<template>
  <v-sheet
    class="cms-styled-image-grid--wrap overflow-hidden"
    :color="fluid ? color : 'transparent'"
    :class="{
      'mb-15': addVerticalSpace,
    }"
  >
    <v-container :fluid="fluid || fluidWithContainedContent">
      <v-sheet :color="color" :class="reducedPadding ? 'pa-4' : 'pa-10'">
        <v-container :fluid="!fluidWithContainedContent">
          <cms-main-heading
            v-if="headline"
            v-bind="headline"
            :primary="headline.primaryColor"
            :dense="headline.reducedVerticalSpace"
          />

          <cms-card-grid
            v-if="imageGrid"
            :cards="imageGrid.imageCards"
            :is-gallery="imageGrid.gallery"
            :align="imageGrid.align"
            class="py-2"
          />

          <cms-html-content
            v-if="text"
            :html="text"
            class="mt-4"
          />
        </v-container>
      </v-sheet>
    </v-container>
  </v-sheet>
</template>
